import cookies from 'js-cookie';

/**
 * 清理所有 cookies
 * 注意：由于浏览器的同源策略，无法直接访问第三方域名的 cookies
 * 但可以清理当前域名下的所有 cookies，以及尝试清理常见的第三方域名
 */
export function clearAllCookies(): void {
  if (typeof document === 'undefined') {
    return;
  }

  // 获取当前域名和主域名
  const hostname = window.location.hostname;
  const domainParts = hostname.split('.');
  const mainDomain = domainParts.length > 1 ? '.' + domainParts.slice(-2).join('.') : hostname;

  // 获取所有 cookies 的键名
  const cookieKeys = cookies.get();

  // 清理当前域名下的所有 cookies（不同路径和域名变体）
  Object.keys(cookieKeys).forEach((key) => {
    // 清理根路径
    cookies.remove(key, { path: '/' });

    // 清理主域名
    if (mainDomain !== hostname) {
      cookies.remove(key, { domain: mainDomain });
    }

    // 清理当前域名
    cookies.remove(key, { domain: hostname });
  });
}

/**
 * 清理网站缓存和 cookies
 * 包括：localStorage, sessionStorage, Cookies
 */
function clearSite(): void {
  // 1. 清理 localStorage
  try {
    localStorage.clear();
  } catch (error) {
    console.warn('清理 localStorage 失败:', error);
  }

  // 2. 清理 sessionStorage（但保留 token 过期处理标记）
  try {
    const tokenFlag = sessionStorage.getItem('_token_expired_handled');
    sessionStorage.clear();
    if (tokenFlag) {
      sessionStorage.setItem('_token_expired_handled', tokenFlag);
    }
  } catch (error) {
    console.warn('清理 sessionStorage 失败:', error);
  }

  // 3. 清理所有 cookies（包括第三方）
  try {
    clearAllCookies();
  } catch (error) {
    console.warn('清理 cookies 失败:', error);
  }
}

export default clearSite;
